import { Subscription, SubscriptionPlan, SubscriptionStatus } from './types';

// Verify ownership and the Backend dictionaries before accepting a snapshot.
export function isSubscriptionForUser(value: unknown, userId: string): value is Subscription {
    if (!value || typeof value !== 'object') return false;
    const data = value as Record<string, unknown>;
    return data.userId === userId
        && Object.values(SubscriptionStatus).some((id) => id === data.subscriptionStatusId)
        && Object.values(SubscriptionPlan).some((id) => id === data.subscriptionPlanId);
}
